/**
 * Enum кодов для кастомизации функционала и интерфейса проекта. См класс @Customization
 */
export enum ErrorCodesEnum {
  FLASHCALL_LOCK_BY_ALL = 'FLASHCALL_LOCK_BY_ALL',
  FLASHCALL_LOCK_BY_IP = 'FLASHCALL_LOCK_BY_IP',
  FLASHCALL_LOCK_BY_PHONE = 'FLASHCALL_LOCK_BY_PHONE',
  FLASHCALL_LOCK_BY_ALL_PWD = 'FLASHCALL_LOCK_BY_ALL_PWD',
  FLASHCALL_EXTERNAL_BADREQUEST = 'FLASHCALL_EXTERNAL_BADREQUEST',
  CHANGE_PASSWORD_LINK_WAS_USED = 'CHANGE_PASSWORD_LINK_WAS_USED',
  CAPTCHA_NOT_VALID = 'CAPTCHA_NOT_VALID',
  //Пользователь ввел неверно креды или капчу и был заблокирован по IP
  LOGIN_WRONG_BLOKED_BY_IP = 'LOGIN_WRONG_BLOKED_BY_IP',
  COUNTRY_NOT_VALID_FOR_CLIENT = 'COUNTRY_NOT_VALID_FOR_CLIENT',
  // Регистрация иностранца не завершена: данные не прошли проверку уникальности (причина не раскрывается)
  STRANGER_REGISTRATION_FAILED = 'STRANGER_REGISTRATION_FAILED',
}
